const Spinner = () => {
  return (
    <div className="loader-box">
      <div className="loader-4"></div>
    </div>
  );
};

export default Spinner;
